import * as React from 'react'
import { Box, Modal, Typography as MIUTypography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import * as rt from '../../config/routeType'
import { styled } from '@mui/material/styles'
import { useSelector, useDispatch } from 'react-redux'
import { setStateModal } from '../../redux/slices/Modal/modalDeleteRecord'
import { updateStatusTreeRegister, getAllLocations } from '../../services'
import { features as setFeature } from '../../redux/slices/Tree/treeFeatures'
import { useLocation } from 'react-router-dom'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 530,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: '25px',
  pb: 1,
  filter:
    'drop-shadow(0px 15px 12px rgba(0, 0, 0, 0.22)) drop-shadow(0px 19px 38px rgba(0, 0, 0, 0.3))',
  textAlign: 'justify',
  borderRadius: '14px',
}

const Typography = styled(MIUTypography)(props => ({
  fontFamily: 'var(--font-family)',
  fontStyle: 'normal',
  fontSize: props.istitle ? '1.2em' : '0.9em',
  fontWeight: props.istitle ? 500 : 400,
  lineHeight: '24px',
  color: props.istitle ? '#1B1C37' : '#6A6A6A',
}))

const DeleteRecordModal = () => {
  const location = useLocation()
  const openModal = useSelector(state => state.modalRemoveTree.showModal)
  const treeId = useSelector(state => state.mapState.currentTreeId)
  const dispatch = useDispatch()
  let navigate = useNavigate()

  const TOKEN = `Bearer ${window.localStorage.getItem('arbolQR_Token')}`

  const handleCancelAction = () => dispatch(setStateModal(false))

  function DeleteTree() {
    return updateStatusTreeRegister(treeId, { habilitado: false }, TOKEN)
      .then(response => {
        if (response.update) return true
        return false
      })
      .catch(err => console.log('Error :>> ', err))
  }

  const handleContinueAction = async () => {
    try {
      const treeDeleted = await DeleteTree()
      dispatch(setStateModal(false))
      if (treeDeleted) {
        getAllLocations()
          .then(geojson => {
            if (!Object.keys(geojson).length)
              console.log('No se pudo cargar los datos. Intente más tarde.')
            else dispatch(setFeature(geojson))
          })
          .catch(err => console.log('Error :>> ', err.message))
        if (location.pathname === `/${rt.MANAGEMENT_TREE}/${rt.TREE}`)
          navigate(0, { replace: true })
        else {
          navigate(`/${rt.MANAGEMENT_TREE}/${rt.TREE}`, { replace: true })
          navigate(0, { replace: true })
        }
      }
    } catch (err) {
      console.log('Error :>> ', err)
    }
  }

  return (
    <div>
      <Modal
        open={openModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        componentsProps={{ backdrop: { sx: { backdropFilter: 'blur(2px)' } } }}
        disableEscapeKeyDown>
        <Box sx={style}>
          <Typography istitle={1} id="modal-modal-title" variant="h6" component="h2">
            Confirmación de acción ¿Desea eliminar el registro?
          </Typography>
          <Typography id="modal-modal-description" sx={{ my: 1 }}>
            El árbol seleccionado será eliminado de la aplicación web.
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
            <Button onClick={handleCancelAction}>Cancelar</Button>
            <Button onClick={handleContinueAction}>Eliminar</Button>
          </Box>
        </Box>
      </Modal>
    </div>
  )
}
export default DeleteRecordModal
